import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BusinessAccounting icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BusinessAccounting } from '@sravni/design-system-icons'
 *
 * <BusinessAccounting />
 * ```
 */
var BusinessAccounting = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BusinessAccounting", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.333 7.5V5.833h-1.666", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4.815 2.5h10.37c.818 0 1.482.746 1.482 1.667v11.666c0 .921-.664 1.667-1.482 1.667H4.815c-.818 0-1.482-.746-1.482-1.667V4.167c0-.921.664-1.667 1.482-1.667v0ZM6.667 11.25h6.666M6.667 14.167H10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m13.333 5.833-2.5 2.5-2.261-1.666-1.905 1.666", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BusinessAccounting };
//# sourceMappingURL=BusinessAccounting.js.map
